import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "../content/defaults";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContentContext = createContext({
  content: DEFAULT_CONTENT,
  loading: false,
  refresh: () => Promise.resolve(),
});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/content`);
      if (res.data) {
        setContent({
          ...DEFAULT_CONTENT,
          ...res.data,
          contact: { ...DEFAULT_CONTENT.contact, ...(res.data.contact || {}) },
          home: { ...DEFAULT_CONTENT.home, ...(res.data.home || {}) },
          services:
            Array.isArray(res.data.services) && res.data.services.length
              ? res.data.services
              : DEFAULT_CONTENT.services,
        });
      }
    } catch (e) {
      // Fallback to defaults on error — site stays functional.
      // eslint-disable-next-line no-console
      console.warn("Content fetch failed, using defaults:", e?.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh, setContent }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
